'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'file-video';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f1c8';
var svgPathData = 'M379.1 146c-3.186-7.688-7.871-14.76-13.87-20.76l-106.5-106.5c-6-6.004-13.07-10.69-20.76-13.88C230.3 1.688 221.1 0 213.5 0H64C46.33 0 30.33 7.164 18.75 18.75S0 46.33 0 64l.0065 384c0 17.67 7.158 33.67 18.74 45.25S46.33 512 64.01 512H320c17.67 0 33.67-7.164 45.26-18.75S384 465.7 384 448V170.5C384 162 382.3 153.7 379.1 146zM224 34.08c2.238 .7813 4.404 1.742 6.443 2.938c2.039 1.199 3.949 2.633 5.676 4.359l106.5 106.5c1.727 1.727 3.16 3.637 4.355 5.676C348.2 155.6 349.1 157.8 349.9 160H240c-4.406 0-8.406-1.793-11.3-4.688C225.8 152.4 224 148.4 224 144V34.08zM352 448c0 8.82-3.588 16.82-9.383 22.62C336.8 476.4 328.8 480 320 480H64c-8.822 0-16.82-3.59-22.62-9.383C35.59 464.8 32 456.8 32 448V64c0-8.82 3.59-16.82 9.383-22.62C47.18 35.59 55.18 32 64 32h128v112c0 13.23 5.383 25.23 14.07 33.93S226.8 192 240 192H352V448zM230.6 265.4C224.8 259.6 216.8 256 208 256H96C87.16 256 79.16 259.6 73.37 265.4C67.58 271.2 64 279.2 64 288v96c0 8.836 3.582 16.84 9.373 22.62C79.16 412.4 87.16 416 96 416h112c8.836 0 16.84-3.582 22.63-9.375c5.023-5.023 7.902-11.87 8.705-19.32l59.61 19.87C300.6 407.7 302.3 408 304 408c3.312 0 6.594-1.031 9.359-3.016C317.5 401.1 320 397.1 320 392v-112c0-5.141-2.469-9.969-6.641-12.98C309.2 264 303.8 263.2 298.9 264.8L239.3 284.7C238.5 277.2 235.7 270.4 230.6 265.4zM208 384H96V288h112V384zM240 318.2L288 302.2v67.59l-48-15.99V318.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileVideo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;